






























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PaymentDetails = Orders.PaymentDetails;

// eslint-disable-next-line no-use-before-define
@Component<PaymentForm>({
  name: 'PaymentForm',
})
export default class PaymentForm extends Vue {
  @Prop({ required: true, type: Boolean })
  show!: boolean;

  @Prop({ required: true, type: Object })
  data!: PaymentDetails;

  @Watch('show')
  toggleOpen(val): void {
    if (val) {
      this.open();
    } else {
      this.close();
    }
  }

  visible: boolean = false;

  $refs!: {
    formData: any;
  };

  defaultMessage = 'Оплатите пожалуйста налоговый сбор';

  epguMessageDescription =
    'Гражданину будет оправлено текстовое сообщение ниже и DOCX-файл вложение со сгенерированной ' +
    'квитанцией на оплату налогового сбора (в соответствии со статьей 333.3 НК РФ)';

  message = '';

  title: string = 'Отправка квитанций';

  open(): void {
    this.visible = true;
    this.message = this.defaultMessage;
  }

  close(): void {
    this.visible = false;
    this.$emit('update:show', this.visible);
  }

  beforeDestroy() {
    this.visible = false;
  }
}
